module.exports = __webpack_public_path__ + "img/txt4.c19606cf.png";